import React, { Component, PropTypes } from 'react';
import PageModule from '../PageModule';
import css from '../css';
import { translate as _l } from 'oxygen-i18n';
import { DropZone, ProgressBar, TextField } from 'cio';
import PageLayoutActions from 'actions/PageLayout';

const videoCss = oxygenCss({
  video: {
    position: 'relative',
    width: '100%'
  }
});

addTranslations({
  ['en-US']: {
    'Write a caption...': 'Write a caption...',
    'Drop a video here': 'Drop a video here',
    'You can also {0}, browse your {1} or {2} one.':
      'You can also {0}, browse your {1} or {2} one.',
    library: 'library',
    embed: 'embed',
    upload: 'upload'
  },
  ['sv-SE']: {}
});

class VideoModuleEditor extends Component {
  static propTypes = {
    children: PropTypes.node
  };

  state = {
    progress: 0
  };

  attach = data => {};

  changeCaption = caption => {
    const { id } = this.props;
    PageLayoutActions.changePageModuleData({
      id,
      data: {
        caption
      }
    });
  };

  render() {
    const { sources, caption, ...other } = this.props;
    const progress = 50;
    const uploading = false;
    const hasSources = sources.length > 0;
    if (uploading > 0) {
      return (
        <PageModule {...other}>
          <div className={css.panel}>
            <div className={css.progress}>{`${Math.round(progress)}%`}</div>
          </div>
          <div className={css.container}>
            <ProgressBar progress={progress} />
          </div>
        </PageModule>
      );
    }
    return (
      <PageModule {...other}>
        {!hasSources && (
          <DropZone
            accept="video/*"
            ref="dropZone"
            onProgress={event => this.setState({ progress: event.percent })}
            onSuccess={this.attach}
          >
            <div className={css.panel}>
              <h2>{_l`Drop a video here`}</h2>
              {_l`You can also ${(
                <a onTouchTap={() => console.log('wut')}>{_l`upload`}</a>
              )}, browse your ${<a>{_l`library`}</a>} or ${(
                <a>{_l`embed`}</a>
              )} one.`}
            </div>
          </DropZone>
        )}
        {hasSources && (
          <video controls className={videoCss.video}>
            {sources.map(source => {
              const extension = source.data.split('.').pop();
              return (
                <source
                  src={source.data}
                  type={`video/${extension}`}
                  key={extension}
                />
              );
            })}
          </video>
        )}
        <div className={css.container}>
          <TextField
            placeholder={_l`Write a caption...`}
            value={caption}
            onChange={this.changeCaption}
          />
        </div>
      </PageModule>
    );
  }
}

export default VideoModuleEditor;



// WEBPACK FOOTER //
// ./src/js/module/Edit/VideoModuleEditor.js